import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/styles/SearchForm.less';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '@/hooks/useDebounce';
const SearchForm = ({ spells, onFilteredChange, defaultFilters }) => {
    const { t } = useTranslation();
    const [nameSearch, setNameSearch] = useState((defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.name) || '');
    const [descSearch, setDescSearch] = useState((defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.description) || '');
    const [level, setLevel] = useState((defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.level) || '');
    const [selectedClass, setSelectedClass] = useState((defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.class) || '');
    const debouncedName = useDebounce(nameSearch, 500);
    const debouncedDesc = useDebounce(descSearch, 1000);
    const uniqueClasses = useMemo(() => {
        return spells
            .flatMap((spell) => { var _a; return (_a = spell.classes) !== null && _a !== void 0 ? _a : []; })
            .reduce((acc, curr) => {
            if (!acc.some((item) => item.index === curr.index)) {
                acc.push({ index: curr.index, name: curr.name });
            }
            return acc;
        }, [])
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [spells]);
    useEffect(() => {
        const found = uniqueClasses.find((c) => c.index === selectedClass || c.name === selectedClass);
        if (found && found.name !== selectedClass) {
            setSelectedClass(found.name);
        }
    }, [selectedClass, uniqueClasses]);
    const filterSpells = useMemo(() => {
        return spells.filter((spell) => {
            var _a, _b;
            const nameMatch = !debouncedName ||
                [spell.name, spell.nameEn, spell.index]
                    .filter(Boolean)
                    .some((s) => s.toLowerCase().includes(debouncedName.toLowerCase()));
            const descMatch = !debouncedDesc ||
                ((_a = spell.desc) === null || _a === void 0 ? void 0 : _a.some((d) => d.toLowerCase().includes(debouncedDesc.toLowerCase())));
            const levelMatch = level === '' || spell.level === level;
            const classMatch = !selectedClass ||
                ((_b = spell.classes) === null || _b === void 0 ? void 0 : _b.some((c) => c.name === selectedClass || c.index === selectedClass));
            return nameMatch && descMatch && levelMatch && classMatch;
        });
    }, [spells, debouncedName, debouncedDesc, level, selectedClass]);
    useEffect(() => {
        onFilteredChange(filterSpells);
    }, [filterSpells, onFilteredChange]);
    return (_jsxs("form", { className: "search-form", children: [_jsx("div", { children: _jsx("input", { id: "name-search", type: "text", value: nameSearch, onChange: (e) => setNameSearch(e.target.value), placeholder: t('spells.searchForm.nameSearch') }) }), _jsx("div", { children: _jsx("input", { id: "desc-search", type: "text", value: descSearch, onChange: (e) => setDescSearch(e.target.value), placeholder: t('spells.searchForm.descriptionSearch') }) }), _jsx("div", { children: _jsxs("select", { id: "level-select", value: level, onChange: (e) => setLevel(e.target.value === '' ? '' : Number(e.target.value)), children: [_jsx("option", { value: "", children: t('spells.searchForm.allLevels') }), Array.from({ length: 10 }, (_, i) => (_jsx("option", { value: i, children: i }, i)))] }) }), _jsx("div", { children: _jsxs("select", { id: "class-select", value: selectedClass, onChange: (e) => setSelectedClass(e.target.value), children: [_jsx("option", { value: "", children: t('spells.searchForm.allClasses') }), uniqueClasses.map((c) => (_jsx("option", { value: c.name, children: c.name }, c.index)))] }) })] }));
};
export default SearchForm;
